import { memo, useState } from "react";
import { useAuthStore } from "@/lib";
import { List, LogOut } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "../ui/button";
import { cn } from "../ui/utils";

export const AdminHeader = memo(({ logout }: { logout: () => void }) => {
  const { user } = useAuthStore();
  const [askBeforeLogoutModal, showAskBeforeLogoutModal] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className="border-b pr-6">
      <div className="h-[54px] min-h-[54px] max-h-[54px] relative bg-white w-full md:hidden">
        <div className="absolute flex gap-1 right-0 top-0">
          {showInfo && (
            <div className="p-1">
              <div className="border bg-white p-2 right-1 top-1 shadow-md">
                <div>{user?.email}</div>
              </div>
            </div>
          )}
          <div
            onClick={() => setShowInfo(!showInfo)}
            className="p-2 select-none"
          >
            <List />
          </div>
        </div>
      </div>
      <div className="h-[54px] min-h-[54px] max-h-[54px] justify-end items-center gap-1 bg-white hidden md:flex">
        <div>{user?.email}</div>
        <div>
          <Button
            variant='ghost'
            onClick={() => showAskBeforeLogoutModal(true)}
            className={cn("w-full text-destructive hover:bg-destructive/10 hover:text-destructive", "justify-start")}
          >
            <LogOut className={cn("w-4 h-4")} />
            Đăng xuất
          </Button>
        </div>
      </div>
      <AlertDialog open={askBeforeLogoutModal} onOpenChange={() => showAskBeforeLogoutModal(false)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Xác nhận đăng xuất</AlertDialogTitle>
            <AlertDialogDescription>Bạn có chắc chắn muốn đăng xuất.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Ở lại</AlertDialogCancel>
            <AlertDialogAction onClick={logout} className='bg-destructive text-destructive-foreground hover:bg-destructive/90'>
              Đăng xuất
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
});
